import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import {
  useHasChangesToBeSaved,
  useResetQuantifyAnalysis,
} from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { trackQuantifyQueryEvents } from '@modules/quantify/utils';
import { ReplayRounded } from '@mui/icons-material';
import { IconButton, Skeleton, Stack, Tooltip } from '@mui/material';
import { captureMessage } from '@sentry/react';
import { useSearchParams } from 'react-router-dom';
import { mapFromEdgeScope } from 'v2/core/repository/edge-server/analysis/fromEdgeAnalysis';
import { shallow } from 'zustand/shallow';

export const ResetQuantifyAction = () => {
  const [, setSearchParams] = useSearchParams();
  const isLoading = useAnalysisStore((analysis) => analysis.isLoading);
  const resetQuantifyAnalysis = useResetQuantifyAnalysis();
  const hasChangesToBeSaved = useHasChangesToBeSaved();

  const { query } = useQuantifyStore((state) => ({
    query: state.query,
  }));

  const { name, href, scope } = useAnalysisStore(
    (analysis) => ({
      name: analysis.title,
      href: analysis.href,
      scope: analysis.scope,
    }),
    shallow,
  );

  const onAnalysisReset = () => {
    resetQuantifyAnalysis();
    setSearchParams({});
    try {
      trackQuantifyQueryEvents({
        eventName: 'Quantify - Reset Icon Clicked',
        query: {
          showMeLabel: query.groupByField?.displayName,
        },
        name,
        link: href,
        scope: mapFromEdgeScope(scope),
      });
    } catch (err) {
      captureMessage('Failed to track Reset Icon event');
    }
  };

  return (
    <Tooltip
      title={
        !hasChangesToBeSaved
          ? 'No changes to reset'
          : 'Reset Quantify to original version'
      }
      placement="bottom"
      disableInteractive
    >
      <Stack>
        <IconButton
          color="primary"
          onClick={onAnalysisReset}
          disabled={!hasChangesToBeSaved}
          data-role="quantify-reset-button"
        >
          {isLoading ? (
            <Skeleton variant="circular" width={24} height={24} />
          ) : (
            <ReplayRounded />
          )}
        </IconButton>
      </Stack>
    </Tooltip>
  );
};
